import { Component, Inject, OnInit } from '@angular/core'
import { OktaAuth } from '@okta/okta-auth-js'
import { OKTA_AUTH } from '@okta/okta-angular'
import { EnvironmentService } from './helpers/environment.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'psdb-ui'
  dynatraceUrl: string = '';
  constructor(@Inject(OKTA_AUTH) private _oktaAuth: OktaAuth , private envService: EnvironmentService) { }

  ngOnInit() {
    this.dynatraceUrl = this.envService.dynatraceUrl;
    this.initializeAuth();
    this.setMyVariableInIndexHtml();
  }
  setMyVariableInIndexHtml() {
    const meta = document.createElement('meta');
    meta.name = 'dynatraceUrl';
    meta.content = this.dynatraceUrl;
    document.getElementsByTagName('head')[0].appendChild(meta);
    const event = new Event('dynatraceUrlSet');
    document.dispatchEvent(event);
  }

  /*
  this is needed since the s3 bucket won't find the /login/callback default login callback.
  Hash based navigation won't work either since hash are not allowed in oauth2 redirect uri

  So we have the redirect to the root page and check here if the user just did a login

  https://github.com/okta/okta-auth-js?tab=readme-ov-file#handling-the-callback-without-routing
   */
  async initializeAuth() {
    // create OktaAuth instance
    // Handle callback
    if (this._oktaAuth.token.isLoginRedirect()) {
      const { tokens } = await this._oktaAuth.token.parseFromUrl(); // remember to "await" this async call
      this._oktaAuth.tokenManager.setTokens(tokens);
    }

    // Subscribe to authState change event.
    this._oktaAuth.authStateManager.subscribe((authState: any) => {
      // Logic based on authState is done here.
      if (!authState.isAuthenticated) {
        // render unauthenticated view
        console.log('User not authenticated');
      } else {
        // Render authenticated view
        console.log('User authenticated');
      }
    });

    // normal app startup
    this._oktaAuth.start(); // will update auth state and call event listeners
  }
}

